import React from "react";
import PropTypes from "prop-types";
import { BULK_SUBSCRIPTION_USER_ROLES } from "common/constants/v2/Constants";
import Menu from "components/v3/bulk-subscriptions/self-serve/manage/menu/ManageBulkSubscriptionMenu";
import styles from "./styles.module.scss";

class ManageUser extends React.Component {
    constructor(props) {
        super(props);

        this._onMenuClick = this._onMenuClick.bind(this);
    }

    _onMenuClick(event) {
        event.stopPropagation();

        const { id, isMenuOpen, showMenu, closeMenu } = this.props;

        if (isMenuOpen) {
            closeMenu();

            return;
        }

        showMenu(id);
    }

    render() {
        const {
            id,
            email,
            verified,
            role,
            success,
            error,
            resetUserAction,
            isMenuOpen,
            closeMenu,
            isSelf,
            numberOfAdmins,
            addAdmin,
            removeAdmin,
            removeUser,
            resendVerificationEmail
        } = this.props;

        const menu = isMenuOpen
            ? (
                <Menu
                    id={ id }
                    email={ email }
                    role={ role }
                    verified={ verified }
                    closeMenu={ closeMenu }
                    numberOfAdmins={ numberOfAdmins }
                    addAdmin={ addAdmin }
                    removeAdmin={ removeAdmin }
                    removeUser={ removeUser }
                    resendVerificationEmail={ resendVerificationEmail }
                />
            )
            : null;
        const userActionClassName = `${ styles.userAction } ${ error ? styles.error : styles.success } ${ (success || error) ? styles.showNotification : "" }`;
        const notificationText = error.message || success.message;

        return (
            <div className={ styles.user }>
                <Email email={ email } unverified={ !verified } isSelf={ isSelf } />
                <Role role={ role } />
                <button className={ `${ styles.menuButton } ${ isSelf ? styles.isSelf : "" }` } type="button" onClick={ this._onMenuClick } />
                { menu }
                <div className={ userActionClassName } onAnimationEnd={ resetUserAction }>
                    { notificationText }
                </div>
            </div>
        );
    }
}

const Email = ({ email, unverified, isSelf }) => {
    return (
        <div className={ unverified ? styles.unverified : styles.verified }>
            <div className={ styles.email } title={ email }>
                { email }{ isSelf ? " (you)" : "" }
            </div>
            { unverified && (
                <div className={ styles.unverifiedText }>
                    Unverified
                </div>
            ) }
        </div>
    );
};

const Role = ({ role }) => {
    if (role !== BULK_SUBSCRIPTION_USER_ROLES.ADMIN) {
        return null;
    }

    return (
        <div className={ styles.role }>
            { role }
        </div>
    );
};

ManageUser.propTypes = {
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    verified: PropTypes.bool,
    role: PropTypes.string.isRequired,
    success: PropTypes.oneOfType([ PropTypes.object, PropTypes.bool ]),
    error: PropTypes.oneOfType([ PropTypes.object, PropTypes.bool ]),
    isMenuOpen: PropTypes.bool,
    resetUserAction: PropTypes.func.isRequired,
    closeMenu: PropTypes.func.isRequired,
    showMenu: PropTypes.func.isRequired,
    isSelf: PropTypes.bool,
    numberOfAdmins: PropTypes.number.isRequired,
    addAdmin: PropTypes.func.isRequired,
    removeAdmin: PropTypes.func.isRequired,
    removeUser: PropTypes.func.isRequired,
    resendVerificationEmail: PropTypes.func.isRequired
};

export default ManageUser;
